import { api } from "lib";
import apiFormData from "lib/apiFormData";

export const getEmployeeGroupByGender = async (params = {}) => {
    return await api.post("/v1/employee/getEmployeeGroupByGender", params);
};
export const getEmployeeGroupByType = async (params = {}) => {
    return await api.post("/v1/employee/getEmployeeGroupByType", params);
};
export const getEmployeeGroupInfoByCompany = async (params = {}) => {
    return await api.post("/v1/employee/getEmployeeGroupInfoByCompany", params);
};
export const getEmployeeSalaryByBranch = async (params = {}) => {
    return await api.post("/v1/employee/getEmployeeSalaryByBranch", params);
};

export const getNewEmployee = async (params = {}) => {
    return await api.post("/v1/employee/getNewEmployeeLastMonth", params);
};
export const getSeparationPage = async (params = {}) => {
    return await api.post("/v1/employee/getSeparationPage", params);
};
export const getPayrollPeriodList = async (params = {}) => {
    return await api.post("/v1/payrollPeriod/getPayrollPeriodYear", params);
};

export const exportHrDashboardExcel = async (params = {}) => {
    return await api.post("/v1/employee/exportHrDashboardExcel", params, {
        responseType: "blob",
    });
};